export default class Podcasts {
    constructor() {
        this.addEvents();
    }
    addEvents() {
        $(document).ready(() => {
            $('.episode__rm-button').on('click',function (e) {
                if($(this).attr('id') === 'episode-read-less') {
                    $('#episode-read-more').show();
                    $('.episode__rm-container').hide();
                } else {
                    $(this).hide();
                    $('.episode__rm-container').show();
                }

            })

            $('.content__rm-button').on('click',function (e) {
                if($(this).hasClass('content-read-less')) {
                    $(this).parents('.content').find('.content-read-more').show();
                    $(this).parents('.content').find('.content__rm-container').hide();
                } else {
                    $(this).hide();
                    $(this).parents('.content').find('.content__rm-container').show();
                }

            })
        });
    }

}
